import axios from '@/http/axios/index.js'


export default {
    getEntities(data) {
        return axios.get('budget/assign/entities')
    },
    getDepartaments(data) {
        return axios.get('budget/assign/departaments')
    },
    getYears(data) {
        return axios.get('budget/assign/years')
    },
    getCategories(data) {
        return axios.get('budget/assign/category')
    },
    list(data) {
        return axios.get('budget/budget-category', { params: data })
    }


}



